import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import './TrustPositioning.css';

const pillars = [
    "Custom Web & Mobile Development",
    "Enterprise Business Systems",
    "AI & Automation",
    "Cloud Infrastructure",
    "Systems Integration",
    "Cybersecurity"
];

const TrustPositioning = () => {
    return (
        <section className="trust-positioning">
            <div className="container">
                <motion.div
                    className="trust-inner"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="trust-text">
                        <span className="trust-eyebrow">Technology Partner</span>
                        <h2 className="trust-heading">
                            We help businesses and organizations build, transform, and grow — through modern digital solutions.
                        </h2>
                        <p className="trust-sub">
                            From your first website to complex enterprise systems, KodeBuild is the engineering team behind your vision.
                        </p>
                    </div>
                    <div className="trust-pillars">
                        {pillars.map((item, i) => (
                            <motion.div
                                key={i}
                                className="trust-pill"
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.08 }}
                            >
                                <CheckCircle2 size={16} className="trust-pill-icon" />
                                {item}
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default TrustPositioning;
